export default __webpack_public_path__ + "static/fullservice-6ca94d71704eab73540b2406f7e5a7da.png";